import { SolicitacaoFiscalizacaoAnalise } from "./SolicitacaoFiscalizacaoAnalise";

export default SolicitacaoFiscalizacaoAnalise;